<template>
  <dash-board-layout :fulid="true">
    <div class="verification section-padding">
      <div class="container h-100">
        <div class="row justify-content-center h-100 align-items-center">
          <div class="col-xl-4 col-md-6">
            <div class="auth-form card">
              <div class="card-header">
                <h4 class="card-title">Link a Debit card</h4>
              </div>
              <div class="card-body">
                <form @submit.prevent="" class="identity-upload">
                  <div class="identity-content">
                    <span class="icon"><i class="fa fa-shield"></i></span>
                    <h4>We are verifying your ID</h4>
                    <p>
                      Your identity is being verified. We will email you once
                      your verification has completed.
                    </p>
                  </div>

                  <div class="upload-loading text-center mb-3">
                    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dash-board-layout>
</template>
<script>
import DashBoardLayout from "../../components/layouts/DashBoardLayout.vue";
export default {
  components: { DashBoardLayout },
  created() {
    setTimeout(() => {
      this.$router.push("/verify-step-4");
    }, 3000);
  },
};
</script>
